import { startGameFlow } from '../game';

/**
 * Skróty deweloperskie pod formularzem zgłoszenia.
 *
 * Przyciski renderują się WYŁĄCZNIE przy APP_ENV=dev (patrz sections/application.html.twig),
 * więc na produkcji ten moduł nie ma czego obsłużyć i po prostu nic nie robi. Backend jest
 * zabezpieczony niezależnie: sentynel uuid gry działa tylko w dev (MemoryController::DEV_UUID).
 */

const SECTION = 'section#application';

function randomInt(max) {
    return Math.floor(Math.random() * max);
}

function randomDigits(count) {
    return Array.from({ length: count }, () => randomInt(10)).join('');
}

/**
 * Wpisuje wartość w pole i budzi to, co na nim wisi.
 *
 * Pola z maską trzymają instancję IMask pod `_imask` (assets/js/form/attributes.js) i to ona
 * jest właścicielem wyświetlanej wartości — samo przypisanie `value` rozjechałoby maskę
 * z polem. Zdarzenia lecą i tak, bo na nich stoją walidatory (np. [data-repeat]).
 */
function fill(input, value) {
    if (!input) return;

    if (input._imask) {
        input._imask.value = String(value);
    } else {
        input.value = value;
    }

    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
}

function fillApplicationForm(form) {
    const field = (name) => form.querySelector(`[name="personal_data[${name}]"]`);

    // Adres z zarezerwowanej domeny example.com — nigdzie nie dojdzie, a przechodzi
    // walidację. Losowy, bo użytkownik jest rozpoznawany po parze e-mail + telefon,
    // więc każde kliknięcie ma dać nowe zgłoszenie.
    const email = `dev.${Date.now().toString(36)}.${randomDigits(3)}@example.com`;
    fill(field('email'), email);
    fill(field('emailRepeat'), email);

    // Polski numer komórkowy: dziewięć cyfr, prefiks +48 dokłada maska.
    fill(field('phone'), `${[4, 5, 6, 7, 8][randomInt(5)]}${randomDigits(8)}`);

    fill(field('billNr'), `DEV${randomDigits(7)}`);

    // Datepicker blokuje wpisywanie z klawiatury (data-no-typing), więc datę ustawiamy
    // przez jego własne API — inaczej wartość i widżet rozjadą się ze sobą.
    const billDate = field('billDate');
    if (billDate) {
        $(billDate).datepicker('update', new Date());
    }

    // Tylko zgody wymagane — opcjonalne zostawiamy, żeby dało się przeklikać wariant
    // minimalny, na którym formularz i tak musi przejść.
    form.querySelectorAll('input[type="checkbox"][required]').forEach((checkbox) => {
        if (!checkbox.checked) {
            checkbox.checked = true;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
    });
}

$(document).on('click', `${SECTION} [data-role="dev-fill"]`, function () {
    const form = this.closest(SECTION)?.querySelector('.application-form');
    if (!form) return;

    fillApplicationForm(form);

    // Okno wyboru pliku otwieramy NA KOŃCU i synchronicznie: przeglądarka wpuszcza je
    // tylko w bezpośredniej reakcji na kliknięcie, więc nic asynchronicznego nie może
    // się tu wcisnąć przed tym wywołaniem.
    form.querySelector('input[type="file"]')?.click();
});

$(document).on('click', `${SECTION} [data-role="dev-game"]`, function () {
    // Sentynel uuid: gra rusza na prawdziwej planszy, ale bez zgłoszenia za sobą —
    // nie powstaje log, nie rosną liczniki prób, żaden wynik się nie zapisuje.
    startGameFlow({ uuid: this.dataset.devUuid });
});
